import { trpc } from "@blis/trpc/react";

import { PrintersTable } from "../components/printers/PrintersTable";
import { Section } from "../components/Section";

export function PrintersPage() {
  const { data } = trpc.printers.list.useQuery();
  return (
    <>
      <Section.Title>Printers</Section.Title>
      <PrintersTable printers={data} />
    </>
  );
}
